import SettingsSectionHeading from 'modules/profile/components/settings-section-heading'
import { FC, ReactNode } from 'react'

export interface ItemStepsProps {
  steps: { key: string; title: ReactNode; element: ReactNode }[]
  hideNumbers?: boolean
  useSectionHeading?: boolean
}

const ItemSteps: FC<ItemStepsProps> = ({ steps, hideNumbers, useSectionHeading }) => (
  <ol className={'flex w-full flex-col gap-10'}>
    {steps.map((step, index) => {
      const title =
        steps.length > 1 && !hideNumbers ? (
          <div className="flex items-center">
            {index + 1}. {step.title}
          </div>
        ) : (
          step.title
        )

      return (
        <li key={step.key} className={'flex flex-col gap-5'}>
          {useSectionHeading ? (
            <SettingsSectionHeading>{title}</SettingsSectionHeading>
          ) : (
            <b className={'text-text-primary font-inter text-sm sm:text-base'}>{title}</b>
          )}
          {step.element}
        </li>
      )
    })}
  </ol>
)

export default ItemSteps
